export const INTEGRATION_STATUS_INTERVAL = 10 * 1000
